var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoFull(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Info full"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 897",
    cx: 8.5,
    cy: 8.5,
    r: 8,
    stroke: "#255056"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.89003 11.4723C7.30381 10.1598 8.08736 8.58756 8.22602 8.18992C8.42631 7.61253 8.07122 7.35648 6.94946 8.34325L6.70001 7.87371C7.97951 6.48196 10.6141 6.16722 9.71755 8.32344C9.15777 9.66971 8.75719 10.5787 8.52829 11.2801C8.19448 12.3021 9.03745 11.8876 9.86282 11.1253C9.97507 11.3087 10.0118 11.3681 10.124 11.5794C8.29132 13.3241 6.25688 13.4781 6.89003 11.4723ZM10.369 5.47905C9.97874 5.8114 9.40061 5.80406 9.07707 5.46291C8.75352 5.12176 8.80782 4.57665 9.19739 4.2443C9.5877 3.91195 10.1658 3.92002 10.4894 4.26044C10.8114 4.60232 10.7586 5.14743 10.369 5.47905Z",
    fill: "#255056"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoFull);
export default __webpack_public_path__ + "static/media/info-full.a75d9b990cfceaf6dfc5ccc1c6078ddc.svg";
export { ForwardRef as ReactComponent };